/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

import React, { FunctionComponent, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { SECONDS_IN_A_MINUTE } from '../../../config';
import { RootState } from '../../../store/root.reducers';
import { PlaybackState } from '../../../store/videoplayerui/infobanner/PlaybackTypes';
import { VideoManager } from '../../../core/videoplayer';

import './TrickplayOsd.scss';

const TrickplayOsd: FunctionComponent = (): JSX.Element => {
    const trickPlayTime = VideoManager.getInstance()
        .getVideoPlayerModel()
        .getTrickPlayTimeInSeconds();
    const { playbackState } = useSelector((state: RootState) => state.videoPlayer);

    const setTrickplayOsdIcon = useCallback(() => {
        switch (playbackState) {
            case PlaybackState.RW3:
                return <img className="osd-rw3-icon" />;
            case PlaybackState.RW2:
                return <img className="osd-rw2-icon" />;
            case PlaybackState.RW1:
                return <img className="osd-rw1-icon" />;
            case PlaybackState.FF3:
                return <img className="osd-ff3-icon" />;
            case PlaybackState.FF2:
                return <img className="osd-ff2-icon" />;
            case PlaybackState.FF1:
                return <img className="osd-ff1-icon" />;
            default:
                return <></>;
        }
    }, [playbackState]);

    const calculateTrickPlayTime = () => {
        let time = '';
        if (trickPlayTime >= SECONDS_IN_A_MINUTE) {
            const seconds = Math.floor(trickPlayTime % SECONDS_IN_A_MINUTE);
            let minutes = Math.floor(trickPlayTime / SECONDS_IN_A_MINUTE);

            if (minutes >= SECONDS_IN_A_MINUTE) {
                const hours = Math.floor(minutes / SECONDS_IN_A_MINUTE);
                minutes %= SECONDS_IN_A_MINUTE;
                if (hours) time += `${hours}h`;
                time += ` ${minutes}m`;
                if (seconds) time += ` ${seconds}s`;
            } else {
                if (minutes) time += `${minutes}m`;
                if (seconds) time += ` ${seconds}s`;
            }
            return time;
        }
        return `${trickPlayTime}s`;
    };

    return (
        <div className="trick-play-osd-container">
            <div className="trick-play-osd-time-icon-container">
                <div className="trick-play-icon" data-test-id="trick-play-icon-image">
                    {setTrickplayOsdIcon()}
                </div>
                <div className="trick-play-time" data-test-id="trick-play-time-text">
                    {calculateTrickPlayTime()}
                </div>
            </div>
        </div>
    );
};

export default TrickplayOsd;
